import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "timi-sidebar" }
const _hoisted_2 = { class: "top" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h1", null, "timi.tools", -1)
const _hoisted_4 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("i", {
        class: "svgicon",
        innerHTML: _ctx.store.getters.svgIcons.timi
      }, null, 8, _hoisted_4)
    ]),
    _createElementVNode("nav", null, [
      _createVNode(_component_router_link, {
        class: _normalizeClass({'is--active': _ctx.checkIsActive(['Dashboard'])}),
        to: "/administration/dashboard"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t("route.dashboard")), 1)
        ]),
        _: 1
      }, 8, ["class"]),
      _createVNode(_component_router_link, {
        class: _normalizeClass({'is--active': _ctx.checkIsActive(['Evaluation'])}),
        to: "/administration/evaluation"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t("route.evaluation")), 1)
        ]),
        _: 1
      }, 8, ["class"]),
      _createVNode(_component_router_link, {
        class: _normalizeClass({'is--active': _ctx.checkIsActive(['EmployeeList', 'EmployeeForm', 'EmployeeDetail'])}),
        to: "/administration/employees"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t("route.employee")), 1)
        ]),
        _: 1
      }, 8, ["class"]),
      _createVNode(_component_router_link, {
        class: _normalizeClass({'is--active': _ctx.checkIsActive(['ClientList', 'ClientForm', 'ClientDetail'])}),
        to: "/administration/clients"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t("route.clients")), 1)
        ]),
        _: 1
      }, 8, ["class"]),
      _createVNode(_component_router_link, {
        class: _normalizeClass({'is--active': _ctx.checkIsActive(['ProjectList', 'ProjectForm', 'ProjectDetail'])}),
        to: "/administration/projects"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t("route.projects")), 1)
        ]),
        _: 1
      }, 8, ["class"]),
      _createVNode(_component_router_link, {
        class: _normalizeClass({'is--active': _ctx.checkIsActive(['WorkList', 'WorkForm'])}),
        to: "/administration/works"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t("route.work")), 1)
        ]),
        _: 1
      }, 8, ["class"]),
      _createVNode(_component_router_link, {
        class: _normalizeClass({'is--active': _ctx.checkIsActive(['DepartmentList', 'DepartmentForm', 'DepartmentDetail'])}),
        to: "/administration/departments"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t("route.departments")), 1)
        ]),
        _: 1
      }, 8, ["class"]),
      _createVNode(_component_router_link, {
        class: _normalizeClass({'is--active': _ctx.checkIsActive(['WorkareaList', 'WorkareaForm'])}),
        to: "/administration/workareas"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t("route.workareas")), 1)
        ]),
        _: 1
      }, 8, ["class"]),
      _createVNode(_component_router_link, {
        class: _normalizeClass({'is--active': _ctx.checkIsActive(['MachineList', 'MachineForm', 'MachineDetail'])}),
        to: "/administration/machines"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t("route.machines")), 1)
        ]),
        _: 1
      }, 8, ["class"]),
      _createVNode(_component_router_link, {
        class: _normalizeClass({'is--active': _ctx.checkIsActive(['VehicleList'])}),
        to: "/administration/vehicles"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t("route.vehicles")), 1)
        ]),
        _: 1
      }, 8, ["class"]),
      _createVNode(_component_router_link, {
        class: _normalizeClass({'is--active': _ctx.checkIsActive(['WorkstationList', 'WorkstationForm'])}),
        to: "/administration/workstations"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t("route.workstations")), 1)
        ]),
        _: 1
      }, 8, ["class"]),
      _createVNode(_component_router_link, {
        class: _normalizeClass({'is--active': _ctx.checkIsActive(['WorkingTimeSchemeList'])}),
        to: "/administration/workingtimeschemes"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t("route.workingTimeScheme")), 1)
        ]),
        _: 1
      }, 8, ["class"]),
      _createVNode(_component_router_link, {
        class: _normalizeClass({'is--active': _ctx.checkIsActive(['CompanySettings'])}),
        to: "/administration/companysettings"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t("route.companySettings")), 1)
        ]),
        _: 1
      }, 8, ["class"]),
      false
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 0,
            class: _normalizeClass({'is--active': _ctx.checkIsActive(['Personalization'])}),
            to: "/administration/personalization"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("route.personalization")), 1)
            ]),
            _: 1
          }, 8, ["class"]))
        : _createCommentVNode("", true),
      _createVNode(_component_router_link, {
        class: _normalizeClass({'is--active': _ctx.checkIsActive(['EmployeegroupList', 'EmployeegroupForm', 'EmployeegroupDetail'])}),
        to: "/administration/employeegroups"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t("route.employeegroup")), 1)
        ]),
        _: 1
      }, 8, ["class"])
    ])
  ]))
}